/**
 * @spec docs/specs/features/staking-position-ui.md#framework-portability-patterns
 * Framework-agnostic route definitions
 *
 * Works with both React Router and Next.js Link.
 * Use these helpers everywhere instead of hardcoded paths.
 */

export const routes = {
  home: () => '/',
  address: (address: string) => `/address/${address}`,
  stake: () => '/stake',
  swap: () => '/swap',
  /** CHIP withdrawal page (CHIP migration). */
  withdraw: () => '/withdraw',
} as const;

// Type helpers for route parameters
export type RouteParams = {
  address: { address: string };
};
